/* eslint-disable max-len */
import { IconButton } from "@mui/material";
import { ArrowLeftIcon } from "assets/Icons";
import dayjs from "dayjs";
import * as User from "providers/user";
import { useRecordContext, useTranslate } from "react-admin";
import { useNavigate } from "react-router-dom";

const CustomHeaderActions = ({
  hasCreate,
  hasExport,
  title,
  createButtonText,
  hideBackButton
}: {
  hasCreate?: boolean;
  hasExport?: boolean;
  title?: string;
  createButtonText?: string;
  hideBackButton?: boolean;
}) => {
  const record = useRecordContext();
  const navigate = useNavigate();
  const { user } = User.useUser();
  const translate = useTranslate();

  const handleGoBack = () => {
    if (window.history.state?.idx > 0) {
      navigate(-1);
    } else {
      navigate("/dashboard");
    }
  };

  return (
    <div
      className={`w-full min-h-[80px] ${
        user.impersonate_company_id ? "mt-[30px]" : ""
      } flex justify-between items-center bg-mono-primaryBgColor gap-4 px-4 xs:px-0`}
    >
      {title ? (
        <div className="flex items-center gap-[16px]">
          {!hideBackButton && (
            <IconButton
              onClick={handleGoBack}
              sx={{
                backgroundColor: "#FAF9F7",
                border: "solid 1px rgba(48, 47, 46, 0.23)"
              }}
            >
              <ArrowLeftIcon />
            </IconButton>
          )}
          <h4 className="font-['OptimaLTStd'] font-[600]">{title}</h4>
        </div>
      ) : (
        <div />
      )}
      <div className="flex flex-col gap-[8px] items-center customListActionsButtonsWrapper">
        {record?.created_at && (
          <p className="font-['Inter'] text-[10px] text-[rgba(48,47,46,0.4)] font-[500] leading-[14px]">
            {translate("common.created_at")}:{" "}
            {dayjs(record?.created_at).format("MM/D/YYYY, hh:mm A")}
          </p>
        )}
        {record?.updated_at && (
          <p className="font-['Inter'] text-[10px] text-[rgba(48,47,46,0.4)] font-[500] leading-[14px]">
            {translate("common.updated_at")}:{" "}
            {dayjs(record?.updated_at).format("MM/D/YYYY, hh:mm A")}
          </p>
        )}
        {/* {hasExport !== false && (
            <ExportButton label="Export to CSV" icon={<DownloadIcon />} />
          )}
          {hasCreate !== false && <CreateButton label={createButtonText} />} */}
      </div>
    </div>
  );
};

export default CustomHeaderActions;
